export let StopLowPriorityEventDelayReason = /*#__PURE__*/function (StopLowPriorityEventDelayReason) {
  StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
  StopLowPriorityEventDelayReason["MANUAL"] = "manual";
  return StopLowPriorityEventDelayReason;
}({});